import styled from 'styled-components';
import BaseAvatar from './Avatar';
import Ico20 from '../Ico20';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Avatar = styled(BaseAvatar)`
  position: absolute;
  left: 0px;
  top: 0px;
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InputButton = styled.label`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background: rgba(38, 50, 56, 0.7);
  position: absolute;
  left: 30px;
  top: 30px;
  z-index: 2;
  border: 0;
  &:disabled {
    cursor: auto;
  }
`;

export const Icon = styled(Ico20)``;

export const Input = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;
